import { Stack, Typography, Button, Grid } from '@mui/material'
import DashboardMainInfoItem from '../../components/DashboardMainInfoItem'
import DashboardDivider from '../../components/DashboardDivider'
import CustomersResellersTable from '../../../Orders/table/CustomersResellersTable'

interface ICustomersResellersTotal {
  revenue: number | string
  numberOfOrders: number
}

interface ICustomersResellers {
  readonly isLoading: boolean
  readonly customersResellersTab: 'all' | 'direct' | 'reseller'
  readonly customersResellers: any
  readonly customersResellersTotal: ICustomersResellersTotal
  readonly onChangeCustomersResellersTab: (tab: 'all' | 'direct' | 'reseller') => void
}

const CustomersResellers = ({
  isLoading,
  customersResellersTab,
  customersResellers,
  customersResellersTotal,
  onChangeCustomersResellersTab,
}: ICustomersResellers) => (
  <Stack p={3} borderRadius={4} spacing={4}>
    <Typography fontSize={16} fontWeight={600} color="primary">
      Active Customers & Resellers - Orders & Revenue
    </Typography>
    <Stack direction="row" spacing={3}>
      <Button
        variant={customersResellersTab === 'all' ? 'contained' : 'text'}
        size="large"
        color="primary"
        onClick={() => onChangeCustomersResellersTab('all')}
      >
        All
      </Button>
      <Button
        variant={customersResellersTab === 'direct' ? 'contained' : 'text'}
        size="large"
        color="primary"
        onClick={() => onChangeCustomersResellersTab('direct')}
      >
        Direct Customers
      </Button>
      <Button
        variant={customersResellersTab === 'reseller' ? 'contained' : 'text'}
        size="large"
        color="primary"
        onClick={() => onChangeCustomersResellersTab('reseller')}
      >
        Resellers
      </Button>
    </Stack>
    <Grid
      container
      alignItems="center"
      sx={{
        gap: { xs: 2, md: 0 },
      }}
    >
      <Grid item sm={3.5} xs={12}>
        <DashboardMainInfoItem
          isLoading={isLoading}
          title="Count"
          value={customersResellers.length}
          textColor="primary"
          noIcon
        />
      </Grid>
      <Grid
        item
        xs={0.75}
        sx={{
          display: { xs: 'none', sm: 'block' },
        }}
      >
        <DashboardDivider />
      </Grid>
      <Grid item sm={3.5} xs={12}>
        <DashboardMainInfoItem
          isLoading={isLoading}
          title="Total Orders"
          value={customersResellersTotal.numberOfOrders}
          textColor="primary"
          noIcon
        />
      </Grid>
      <Grid
        item
        xs={0.75}
        sx={{
          display: { xs: 'none', sm: 'block' },
        }}
      >
        <DashboardDivider />
      </Grid>
      <Grid item sm={3.5} xs={12}>
        <DashboardMainInfoItem
          isLoading={isLoading}
          title="Total Revenue"
          value={
            typeof customersResellersTotal.revenue === 'number'
              ? `€${customersResellersTotal.revenue.toLocaleString('de-DE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : customersResellersTotal.revenue
          }
          textColor="primary"
          noIcon
        />
      </Grid>
    </Grid>
    <CustomersResellersTable customersResellers={customersResellers} />
  </Stack>
)

export default CustomersResellers
